import * as React from 'react';

function SvgCloudyFill(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M13.405 7.027a5.001 5.001 0 00-9.499-1.004A3.5 3.5 0 103.5 13H13a3 3 0 00.405-5.973z' />
		</svg>
	);
}

export default SvgCloudyFill;
